export default __webpack_public_path__ + "static/media/investment_male@3x.343432ef.png";